import './zod-config';
// Token thiết kế trước style nền (styles.css ánh xạ biến cũ sang --ws-*), rồi tới component/bố cục (nạp qua App).
import './design/tokens.css';
import './styles.css';
import { lazy, StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { EmbedApp } from './embed/EmbedApp';
import { reloadForNewRelease } from './lib/release';
import { registerServiceWorker } from './lib/pwa';
import { applyStoredTheme } from './workspace/theme';

// `/design`: màn hình phác thảo giao diện với dữ liệu giả — chỉ có khi chạy dev (`vite`). Bản build production thay
// `import.meta.env.DEV` bằng `false` → nhánh này (và chunk của màn hình) bị loại khỏi bundle, `/design` mở app thường.
const WorkspaceDesign = import.meta.env.DEV
  ? lazy(() => import('./screens/PortalWorkspace').then((m) => ({ default: m.PortalWorkspace })))
  : null;

// `/download`: trang tải bản cài đặt công khai — không đăng nhập, không khởi tạo client chat.
const DownloadPage = lazy(() => import('./download/DownloadPage').then((m) => ({ default: m.DownloadPage })));
const isDownload = /^\/download\/?$/.test(window.location.pathname);

const isEmbed = window.location.pathname.startsWith('/embed');
const isDesign = WorkspaceDesign !== null && window.location.pathname === '/design';
// Q3: PWA chỉ cho web chính — chế độ nhúng trong iframe portal không cài/không cache/không nhận push.
if (!isEmbed && !isDesign) registerServiceWorker();
applyStoredTheme();

// Bản phát hành mới thay chunk có hash: tab đang mở bản cũ nạp chunk lười (vd. BotsDialog) sẽ lỗi 404 → tải lại một lần để lấy bản mới.
window.addEventListener('vite:preloadError', (e) => {
  if (reloadForNewRelease()) e.preventDefault();
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    {isDownload ? (
      <Suspense fallback={null}>
        <DownloadPage />
      </Suspense>
    ) : isDesign && WorkspaceDesign ? (
      <Suspense fallback={null}>
        <WorkspaceDesign />
      </Suspense>
    ) : isEmbed ? (
      <EmbedApp />
    ) : (
      <App />
    )}
  </StrictMode>,
);
